import { Map } from 'immutable';

import Issue from './scenes/Issues/index';
import IssueDetails from './scenes/Issues/details';
import IssueCreate from './scenes/Issues/create';

export default new Map({
    /** Home */
    '/issues': {
        firstPage: true,
        must_logged: true,
        component: Issue,
        right: 'issuesList'
    },
    '/issues/:issueId/projects/:projectId': {
        must_logged: true,
        component: IssueDetails,
        right: 'issueDetails'
    },
    '/issues/create': {
        must_logged: true,
        component: IssueCreate,
        right: 'issueCreate'
    }
});



// WEBPACK FOOTER //
// ./environments/ticketsgit/routes.js